import { render, staticRenderFns } from "./careerCounseling.vue?vue&type=template&id=24d26af0&"
import script from "./careerCounseling.vue?vue&type=script&lang=js&"
export * from "./careerCounseling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports